import { motion } from "framer-motion";
import { GALLERY } from "../data/content";
import { SectionLabel } from "./Section";
import { fadeUp, viewport } from "../lib/motion";

const Gallery = () => (
  <section id="gallery" className="relative py-16 sm:py-32" data-testid="gallery-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-12">
        <div className="max-w-2xl">
          <SectionLabel>Gallery</SectionLabel>
          <motion.h2
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={viewport}
            className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.1]"
          >
            A little taste of <span className="text-highlight">the Detour life.</span>
          </motion.h2>
        </div>
      </div>

      <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 [column-fill:_balance]">
        {GALLERY.map((item, i) => (
          <motion.figure
            key={i}
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.15 }}
            className="group relative mb-5 break-inside-avoid overflow-hidden rounded-2xl shadow-warm"
            data-testid={`gallery-item-${i}`}
          >
            <div style={{ aspectRatio: item.ratio }} className="w-full overflow-hidden">
              <img
                src={item.img}
                alt={item.label}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
            </div>
            <figcaption className="absolute inset-0 flex items-end p-5 bg-gradient-to-t from-black/70 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100">
              <span className="text-background text-sm font-medium tracking-wide">{item.label}</span>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);

export default Gallery;
